import utils, { readyToVerify } from '@/utils/utils'
import { isValidToken } from '@/utils/session'

import { idleSubmitting } from '../utils/submitting'

const getStartAuth = () => {
  try {
    return isValidToken(utils.getToken())
  } catch (error) {}

  return false
}

export const createInitialAuthState = () => ({
  loginStatus: null,
  submittingState: idleSubmitting(),
  isFailedLogin: false,
  userData: null,
  fbFailed: null,
  fbData: null,
  isAuthenticated: getStartAuth(),
  isInitialized: false,
  sessionsData: null,
  isLoginSuccess: false,
  isLoginFacebookSuccess: false,
  closeSessionsStatus: true,
  isSessionExpired: false,
  authNotice: null,
  readyToVerify: readyToVerify(),
  jwt: null,
  errorList: [],
  turnstileWidgetId: null,
  authPageStep: null,
  notLoggedData: null,
})

export const initialAuthState = createInitialAuthState()
